import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.background,
      padding: spacing.m,
      borderRadius: constants.radius.view,
    },
    contact: {
      width: 40,
      height: 40,
      borderRadius: 50,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    name: {
      marginLeft: spacing.xs,
    },
  };

  return styles;
};
